import { render } from "./RecuperarPassword.vue?vue&type=template&id=4c7dd90d&scoped=true"
import script from "./RecuperarPassword.vue?vue&type=script&lang=js"
export * from "./RecuperarPassword.vue?vue&type=script&lang=js"

import "./RecuperarPassword.vue?vue&type=style&index=0&id=4c7dd90d&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7dd90d"]])

export default __exports__